import { render, staticRenderFns } from "./SignInBox.vue?vue&type=template&id=4291db03&"
import script from "./SignInBox.vue?vue&type=script&lang=ts&"
export * from "./SignInBox.vue?vue&type=script&lang=ts&"
import style0 from "./SignInBox.vue?vue&type=style&index=0&id=4291db03&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4291db03')) {
      api.createRecord('4291db03', component.options)
    } else {
      api.reload('4291db03', component.options)
    }
    module.hot.accept("./SignInBox.vue?vue&type=template&id=4291db03&", function () {
      api.rerender('4291db03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/components/SignInBox.vue"
export default component.exports